module.exports = __webpack_public_path__ + "static/media/1968 Delhi, India.9906403f.jpg";